import { MdEdit } from 'react-icons/md'
import DetailsTag from './DetailsTag'
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { formatUSPhone } from '../../utils/phoneFormatter';
import { getMyCdirAddressByTenantId } from '../../services/BillingAddress';
import useGroup from '../../hook/useGroup';

type BillingAddressProps = {
  setShowPopupUpdateBillingAddress: (value: boolean) => void;
  billingAddressData: any;
  setBillingAddressData: (value: any) => void;
}

const BillingAddress = ({ setShowPopupUpdateBillingAddress, billingAddressData, setBillingAddressData }: BillingAddressProps) => {
  const { selectedTenantId, isSuperAdmin }: any = useGroup();
  const tenantId = isSuperAdmin
    ? selectedTenantId
    : Cookies.get("tenantId-my-cdir");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (tenantId) {
      setLoading(true);
      getMyCdirAddressByTenantId(tenantId)
        .then(res => {
          setBillingAddressData(res);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId])

  const editTheBillingAddress = () => {
    setShowPopupUpdateBillingAddress(true);
  }


  return (
    <div className="w-full border border-secondary rounded-md">

      <div className="text-primary bg-secondary px-4 py-2 w-full flex justify-between items-center">
        <h4 className="font-medium text-primary">Billing Address</h4>

        <MdEdit
          className="cursor-pointer"
          onClick={editTheBillingAddress}
        />
      </div>

      {loading ? (
        <div className="flex flex-col items-center justify-center py-12 gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-[#2B3998]" />
          <span className="text-sm text-gray-500">
            Loading...
          </span>
        </div>
      ) : (
        <div className="flex flex-col p-4 gap-y-3">
          <DetailsTag
            title="Company Name"
            value={billingAddressData?.name}
          />

          <div className="flex gap-x-4">
            <DetailsTag
              title="Email"
              value={billingAddressData?.emailAddress}
            />

            <DetailsTag
              title="Phone Number"
              value={formatUSPhone(billingAddressData?.phoneNumber || "")}
            />
          </div>

          <div className="flex gap-x-4">
            <DetailsTag
              title="Street"
              value={billingAddressData?.street}
            />

            <DetailsTag
              title="Street 2"
              value={billingAddressData?.street2}
            />

            <DetailsTag
              title="ZIP"
              value={billingAddressData?.zip}
            />

          </div>

          <div className="flex gap-x-4">
            <DetailsTag
              title="State"
              value={"TX"}
            />

            <DetailsTag
              title="City"
              value={billingAddressData?.city}
            />

            <DetailsTag
              title="Country"
              value={billingAddressData?.country}
            />
          </div>

        </div>
      )}
    </div>
  )
}

export default BillingAddress;
